"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.hydrateBakers = exports.asBaker = exports.useRandomBaker = exports.useBaker = exports.useDelegation = exports.loadAccountDelegation = exports.loadBaker = exports.isAccountDelegating = exports.getAccountDelegationSync = exports.getBakerSync = exports.useBakers = exports.listBakers = exports.fetchAllBakers = void 0;
var react_1 = require("react");
var logs_1 = require("@ledgerhq/logs");
var cache_1 = require("../../cache");
var env_1 = require("../../env");
var network_1 = __importDefault(require("../../network"));
var capacityStatuses = {
    normal: null,
    full: null
};
var cache = (0, cache_1.makeLRUCache)(function () { return __awaiter(void 0, void 0, void 0, function () {
    var base, data, bakers;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                base = (0, env_1.getEnv)("API_TEZOS_BAKER");
                return [4 /*yield*/, (0, network_1["default"])({
                        url: "".concat(base, "/v2/bakers")
                    })];
            case 1:
                data = (_a.sent()).data;
                bakers = [];
                if (data && typeof data === "object" && Array.isArray(data)) {
                    (0, logs_1.log)("tezos/bakers", "found " + data.length + " bakers");
                    data
                        .filter(function (raw) { return raw.serviceHealth === "active"; })
                        .forEach(function (raw) {
                        var baker = (0, exports.asBaker)(raw);
                        if (baker) {
                            bakers.push(baker);
                        }
                    });
                }
                (0, logs_1.log)("tezos/bakers", "loaded " + bakers.length + " bakers");
                return [2 /*return*/, bakers];
        }
    });
}); }, function () { return ""; });
var _lastBakers;
var fetchAllBakers = function () { return __awaiter(void 0, void 0, void 0, function () {
    var r;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, cache.force()];
            case 1:
                r = _a.sent();
                _lastBakers = r;
                return [2 /*return*/, r];
        }
    });
}); };
exports.fetchAllBakers = fetchAllBakers;
function whitelist(all, addresses) {
    var map = {};
    all.forEach(function (b) {
        map[b.address] = b;
    });
    return addresses.map(function (addr) { return map[addr]; }).filter(Boolean);
}
var listBakers = function (whitelistAddresses) { return __awaiter(void 0, void 0, void 0, function () {
    var all;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, cache()];
            case 1:
                all = _a.sent();
                _lastBakers = all;
                return [2 /*return*/, whitelist(all, whitelistAddresses)];
        }
    });
}); };
exports.listBakers = listBakers;
function useBakers(whitelistAddresses) {
    var _a = __read((0, react_1.useState)(function () {
        return whitelist(_lastBakers || [], whitelistAddresses);
    }), 2), bakers = _a[0], setBakers = _a[1];
    (0, react_1.useEffect)(function () {
        var cancelled;
        (0, exports.listBakers)(whitelistAddresses).then(function (bakers) {
            if (cancelled)
                return;
            setBakers(bakers);
        });
        return function () {
            cancelled = true;
        };
    }, [whitelistAddresses]);
    return bakers;
}
exports.useBakers = useBakers;
function getBakerSync(addr) {
    if (_lastBakers) {
        return _lastBakers.find(function (baker) { return baker.address === addr; });
    }
}
exports.getBakerSync = getBakerSync;
function getAccountDelegationSync(account) {
    var op = account.operations.find(function (op) {
        return !op.hasFailed && (op.type === "DELEGATE" || op.type === "UNDELEGATE");
    });
    var pendingOp = account.pendingOperations
        .filter(function (op) { return !account.operations.some(function (o) { return op.hash === o.hash; }); })
        .find(function (op) { return op.type === "DELEGATE" || op.type === "UNDELEGATE"; });
    var isPending = !!pendingOp;
    var operation = pendingOp && pendingOp.type === "DELEGATE" ? pendingOp : op;
    if (!operation || operation.type === "UNDELEGATE") {
        return null;
    }
    var recentOps = account.operations
        .filter(function (op) { return op.date > operation.date; })
        .concat(account.pendingOperations);
    var sendShouldWarnDelegation = !recentOps.some(function (op) { return op.type === "OUT"; });
    var receiveShouldWarnDelegation = !recentOps.some(function (op) { return op.type === "IN"; });
    return {
        isPending: isPending,
        operation: operation,
        address: operation.recipients[0],
        baker: null,
        sendShouldWarnDelegation: sendShouldWarnDelegation,
        receiveShouldWarnDelegation: receiveShouldWarnDelegation
    };
}
exports.getAccountDelegationSync = getAccountDelegationSync;
function isAccountDelegating(account) {
    return !!getAccountDelegationSync(account);
}
exports.isAccountDelegating = isAccountDelegating;
function loadBaker(addr) {
    return __awaiter(this, void 0, void 0, function () {
        var cacheBaker, bakers, baker;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    cacheBaker = getBakerSync(addr);
                    if (cacheBaker)
                        return [2 /*return*/, Promise.resolve(cacheBaker)];
                    return [4 /*yield*/, cache()];
                case 1:
                    bakers = _a.sent();
                    baker = bakers.find(function (baker) { return baker.address === addr; });
                    return [2 /*return*/, baker];
            }
        });
    });
}
exports.loadBaker = loadBaker;
function loadAccountDelegation(account) {
    return __awaiter(this, void 0, void 0, function () {
        var d, baker;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    d = getAccountDelegationSync(account);
                    if (!d)
                        return [2 /*return*/, Promise.resolve(null)];
                    return [4 /*yield*/, loadBaker(d.address)];
                case 1:
                    baker = _a.sent();
                    return [2 /*return*/, __assign(__assign({}, d), { baker: baker })];
            }
        });
    });
}
exports.loadAccountDelegation = loadAccountDelegation;
function useDelegation(account) {
    var _a = __read((0, react_1.useState)(function () {
        return getAccountDelegationSync(account);
    }), 2), delegation = _a[0], setDelegation = _a[1];
    (0, react_1.useEffect)(function () {
        var cancelled;
        loadAccountDelegation(account).then(function (delegation) {
            if (cancelled)
                return;
            setDelegation(delegation);
        });
        return function () {
            cancelled = true;
        };
    }, [account]);
    return delegation;
}
exports.useDelegation = useDelegation;
function useBaker(addr) {
    var _a = __read((0, react_1.useState)(function () { return getBakerSync(addr); }), 2), baker = _a[0], setBaker = _a[1];
    (0, react_1.useEffect)(function () {
        var cancelled;
        loadBaker(addr).then(function (baker) {
            if (cancelled)
                return;
            setBaker(baker);
        });
        return function () {
            cancelled = true;
        };
    }, [addr]);
    return baker;
}
exports.useBaker = useBaker;
//  select a random baker for the mount time (assuming bakers length don't change)
function useRandomBaker(bakers) {
    var randomBakerIndex = (0, react_1.useMemo)(function () {
        var nonFullBakers = bakers.filter(function (b) { return b.capacityStatus !== "full"; });
        if (nonFullBakers.length > 0) {
            // if there are non full bakers, we pick one
            var i = Math.floor(Math.random() * nonFullBakers.length);
            return bakers.indexOf(nonFullBakers[i]);
        }
        // fallback on random between only full bakers
        return Math.floor(Math.random() * bakers.length); // for perf, we only want to re-calc on bakers.length changes
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [bakers.length]);
    return bakers[randomBakerIndex];
}
exports.useRandomBaker = useRandomBaker;
var asBaker = function (data) {
    if (data && typeof data === "object") {
        var address = data.address, name_1 = data.name, logo = data.logo, freeSpace = data.freeSpace, estimatedRoi = data.estimatedRoi;
        if (typeof name_1 === "string" &&
            typeof address === "string" &&
            typeof logo === "string" &&
            (logo.startsWith("https://") || logo.startsWith("http://")) &&
            typeof freeSpace === "number" &&
            typeof estimatedRoi === "number" &&
            0 <= estimatedRoi &&
            estimatedRoi <= 1) {
            return {
                name: name_1,
                address: address,
                logoURL: logo,
                nominalYield: Math.floor(10000 * estimatedRoi) / 100 + " %",
                capacityStatus: freeSpace <= 0 ? "full" : "normal"
            };
        }
    }
};
exports.asBaker = asBaker;
var hydrateBakers = function (bakers) {
    (0, logs_1.log)("tezos/bakers", "hydrate " + bakers.length + " bakers");
    cache.hydrate("", bakers);
};
exports.hydrateBakers = hydrateBakers;
//# sourceMappingURL=bakers.js.map